import { useLocation, useNavigate } from 'react-router-dom';
import SearchBar from '../SearchBar/SearchBar';
import './SearchSection.css';
export default function SearchSection() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = location.pathname === '/search' ? (new URLSearchParams(location.search).get('q') ?? '') : '';
  return (
    <div className="search-section">
      <SearchBar
        key={`${location.pathname}:${location.search}`}
        initialQuery={query}
        onSearch={(value) => navigate(`/search?${new URLSearchParams({ q: value })}`)}
        onClear={() => {
          if (location.pathname === '/search') navigate('/');
        }}
      />
    </div>
  );
}
